module.exports = __webpack_public_path__ + "assets/img/szjz_2.8f2dff5f.png";